import {
  ApplicationConfig,
  inject,
  Injector,
  provideAppInitializer,
  provideZonelessChangeDetection,
  runInInjectionContext,
} from '@angular/core';
import {
  provideRouter,
  TitleStrategy,
  withRouterConfig,
} from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { apiAuthInterceptor } from './common/interceptors/apiauth.interceptor';
import { DATE_PIPE_DEFAULT_OPTIONS } from '@angular/common';
import { TemplatePageTitleStrategy } from './common/services/template-page-title.strategy';
import { AuthService } from './common/services/auth.service';
import { concat, lastValueFrom, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionService } from './common/services/session.service';
import { loadRuntimeConfig } from './common/config/runtime-config';
import { providePortalAuthGateway } from './common/services/auth-gateway';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload' })),
    { provide: TitleStrategy, useClass: TemplatePageTitleStrategy },
    provideHttpClient(withInterceptors([apiAuthInterceptor])),
    providePortalAuthGateway(),
    provideAnimationsAsync(),
    provideAppInitializer(() => {
      const injector = inject(Injector);
      return loadRuntimeConfig().then(() =>
        runInInjectionContext(injector, () =>
          lastValueFrom(
            concat(
              inject(AuthService)
                .getIpAddress()
                .pipe(
                  catchError((err) => {
                    console.warn(
                      '[APP_INIT] getIpAddress failed; continuing',
                      err,
                    );
                    return of('0.0.0.0');
                  }),
                ),
              inject(SessionService)
                .ensureSession$()
                .pipe(
                  catchError((err) => {
                    console.warn(
                      '[APP_INIT] ensureSession failed; continuing',
                      err,
                    );
                    return of(null);
                  }),
                ),
            ),
          ),
        ),
      );
    }),
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { dateFormat: 'yyyy-MM-dd' },
    },
  ],
};
